import type { Locale } from '@shared/libs';

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

/**
 * Фильтрует FAQ из переводов по типу аранжировки
 * @param locale - объект с переводами
 * @param urlArrangement - код аранжировки из URL
 * @returns массив отфильтрованных вопросов-ответов
 */
export function filterFaqByArrangement(locale: Locale, urlArrangement: string | null): FaqItem[] {
  if (!urlArrangement) {
    return [];
  }

  const faqItems: FaqItem[] = [];
  const pattern = new RegExp(`^${urlArrangement}_([QA])_(\\d+)$`);
  
  // Создаем мапу для сопоставления вопросов и ответов
  const questionsMap = new Map<number, string>();
  const answersMap = new Map<number, string>();
  
  // Проходим по всем ключам locale и ищем подходящие FAQ
  Object.entries(locale as Record<string, unknown>).forEach(([key, value]) => {
    const match = key.match(pattern);
    if (match && typeof value === 'string') {
      const [, type, numberStr] = match;
      const number = parseInt(numberStr, 10);
      
      if (type === 'Q') {
        questionsMap.set(number, value);
      } else if (type === 'A') {
        answersMap.set(number, value);
      }
    }
  });
  
  // Создаем итоговый массив FAQ, соединяя вопросы с ответами
  const numbers = Array.from(new Set([...questionsMap.keys(), ...answersMap.keys()])).sort((a, b) => a - b);
  
  numbers.forEach((number) => {
    const question = questionsMap.get(number);
    const answer = answersMap.get(number);
    
    if (question && answer) {
      faqItems.push({
        id: `${urlArrangement}_${number}`,
        question,
        answer,
      });
    }
  });
  
  return faqItems;
}
